<div class="bpx-page">
  <h2 class="bpx-page__title" i18n>Run Status</h2>

  <mat-tab-group (selectedTabChange)="selectedTabChangeHandler($event)">
    <mat-tab label="Sample Errors" i18n i18n-label>
      <div class="bpx-tab-content" *ngIf="tabChangeEvent === 'Sample Errors'">
        <app-sample-errors></app-sample-errors>
      </div>
    </mat-tab>
    <mat-tab label="Rerun Samples" i18n i18n-label>
      <div class="bpx-tab-content" *ngIf="tabChangeEvent === 'Rerun Samples'">
        <app-rerun-samples></app-rerun-samples>
      </div>
    </mat-tab>
    <mat-tab label="Instrument Errors" i18n i18n-label>
      <div class="bpx-tab-content" *ngIf="tabChangeEvent === 'Instrument Errors'">
        <app-instrument-errors></app-instrument-errors>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
